import { useQuery } from '@tanstack/react-query'
import { getMyTasks } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

/**
 * 自分のタスク一覧取得フック（マイページ用）
 */
export function useMyTasks(params?: { offset?: number; limit?: number }) {
  return useQuery({
    queryKey: queryKeys.myTasksList(params),
    queryFn: async () => {
      return getMyTasks(params)
    },
  })
}
